<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>CAMPUS LIFE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Hostel</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="section-heading text-start mb-0 text-center">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">Our Hostel</h2>
        <p>There are separate Hostels for Boys and Girls with all the modern and comfort facilities. The rooms are well
            furnished, spacious and airy to enable the living of students as comfortable as possible. In fact it is with
            a concept to have “Home away from Home”. We cater for approx 700 students on double and triple sharing
            basis. We pay special attention for the safety and comforts of the students, especially the Girl students so
            that they all feel secured, comfortable and confident.</p>
        <ul>
            <li>The Hostel caution money and room rent are payable on allotment of the room in advance for the whole
                Semester, along with the Tuition fee, as per the rules approved by the Govt of HP. The admission in the
                Hostel cannot be withdrawn before one academic year. WI – FI CAMPUS
            </li>
        </ul>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/Hostel1.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/Hostel2.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/Hostel3.jpg" class="cover-background w-100 h-100"/>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/Hostel4.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>
<!--
        <div class="section-heading text-start mb-0 text-center mt-5 ">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">Our Mess</h2>
        <p>The University has two separate large Dining Halls for the Boy and Girl hostellers, connected with their
            Hostels to ensure their better time management and security. The menu is decided by the Mess Committee,
            comprising of students from all hostels and the Wardens. The Mess charges are paid in advance for whole
            Semester, in the beginning of each Semester along with other charges of the University.</p>
        <ul>
            <li>All seasonal vegtable are availble according to season</li>
        </ul>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/Mess.jpg" class="cover-background w-100 h-100"/>
            </div>

&lt;!&ndash;            <div class="col-lg-3 col-md-3 col-sm-12">&ndash;&gt;
&lt;!&ndash;                <img src="assets/img/hostel/Mess2.jpg" class="cover-background w-100 h-100"/>&ndash;&gt;
&lt;!&ndash;            </div>&ndash;&gt;

&lt;!&ndash;            <div class="col-lg-3 col-md-3 col-sm-12">&ndash;&gt;
&lt;!&ndash;                <img src="assets/img/hostel/Mess3.jpg" class="cover-background w-100 h-100"/>&ndash;&gt;
&lt;!&ndash;            </div>&ndash;&gt;
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/Mess4.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>-->
    </div>
</section>
